import { render } from "./AppVetMenu.vue?vue&type=template&id=84e2642c"
import script from "./AppVetMenu.vue?vue&type=script&lang=js"
export * from "./AppVetMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__